
import React from "react";
import Article from '../Components/Dashboard/Resource-Center/Article';
import SessionTimeoutRedirect from '../Components/Common/SessionTimeoutRedirect'
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
const AuthArticle = () => {
  const useAuth=()=>{
    const user=localStorage.getItem('user_id')
    const token = document.cookie.replace(/(?:(?:^|.*;\s*)token\s*=\s*([^;]*).*$)|^.*$/, '$1');

    if(token){
      return true
    } else {
      localStorage.clear()
      return false
    }
  }
  const auth = useAuth();
  return auth ? <Article /> : <SessionTimeoutRedirect />
}
export default AuthArticle;


